const namespaced = true;

const defaultState = () => {
  return {
    modal: {
      show: false,
      id: null,
    },
    refreshRequired: false,
  };
};

const state = defaultState();

const actions = {};

const mutations = {
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_MODAL(state, modal) {
    state.modal = modal;
  },
  SET_REFRESH_REQUIRED(state, refreshRequired) {
    state.refreshRequired = refreshRequired;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
